namespace GeniuzPOS.LogManage {
    export class LogUserPasswordChangeDateColumns {
        static columnsKey = 'LogManage.LogUserPasswordChangeDate';
    }
}
